import { createReducer, on } from "@ngrx/store";
import { NotificationActions } from "../actions";
import { AppTriggeredNotification } from "src/app/models/notifications/notification";

export interface NotificationState {
  activeNotifications: AppTriggeredNotification[];
}

const initialState = {
  activeNotifications: [],
} as NotificationState;

export const notificationReducer = createReducer(
  initialState,
  on(NotificationActions.notificationTriggered, (state, action) => ({
    ...state,
    activeNotifications: [
      ...state.activeNotifications,
      action.triggeredNotification,
    ],
  })),
  on(NotificationActions.clearNotification, (state, action) => ({
    ...state,
    activeNotifications: state.activeNotifications.filter(
      (n) => n.id != action.notification.id,
    ),
  })),
);
